import { PropertyTag } from "./property-tag.tsx";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";

export interface PropertyTagsDisplayProps {
  className?: string;
  showVideoAndTourTags?: boolean;
}

export const PropertyTagsDisplay = ({ className, showVideoAndTourTags }: PropertyTagsDisplayProps) => {
  const { exclusive, newAdd, underOffer, closingText, newBuild, premium, featured, video, virtualTour } =
    usePropertyDetailsContext();
  if (
    !exclusive &&
    !newAdd &&
    !underOffer &&
    !closingText &&
    !newBuild &&
    !premium &&
    !featured &&
    !video &&
    !virtualTour
  ) {
    return null;
  }
  return (
    <ul aria-label="Property features" className={className}>
      {exclusive && (
        <li>
          <PropertyTag type="exclusive" />
        </li>
      )}
      {newAdd && !underOffer && (
        <li>
          <PropertyTag type="new" />
        </li>
      )}
      {closingText && (
        <li>
          <PropertyTag type="closing-date" textOverride={closingText} />
        </li>
      )}
      {underOffer && (
        <li>
          <PropertyTag type="under-offer" />
        </li>
      )}
      {newBuild && (
        <li>
          <PropertyTag type="new-build" />
        </li>
      )}
      {premium && (
        <li>
          <PropertyTag type="premium" />
        </li>
      )}
      {featured && (
        <li>
          <PropertyTag type="featured" />
        </li>
      )}
      {video && showVideoAndTourTags && (
        <li>
          <PropertyTag type="video" />
        </li>
      )}
      {virtualTour && showVideoAndTourTags && (
        <li>
          <PropertyTag type="virtual-tour" />
        </li>
      )}
    </ul>
  );
};
